export enum ActionType {
  Reject,
  Confirm,
}
